import type { ReactNode } from "react";
import { cn } from "./cn";
import type { RozetTonu } from "./Rozet";

/**
 * ÇİP — tablo ve satır içi sınıflandırma etiketi
 *
 * ================================================================
 * `Rozet` İLE AYNI DEĞİL: AYIRAN ŞEY YARIÇAP
 * ================================================================
 * Teslim notu şunu yazıyor: "Bilgi bandı ile durum rozetini ayıran
 * şey yarıçap: rozet `radius-rozet` taşır." Ben bunu 04.09.2026'da
 * `Onaylarim`da fazla geniş uyguladım — sayfadaki her durum etiketini
 * `Rozet`e çevirdim. **Yanlıştı.**
 *
 * Artboard'lara tek tek bakınca ölçülen şey şu: tablo ve satır içi
 * etiketler `radius-alan` + `2px 9px` + 12px/500 taşıyor.
 *
 *   `Ogrenciler.dc.html`  "Aktif" · "Mezun"        → radius-alan
 *   `Onaylarim.dc.html`   "Okundu"                 → radius-alan
 *   `Kuyruk.dc.html`      "Uzman değişikliği"      → radius-alan
 *
 * `radius-rozet` (tam yuvarlak) SAYI taşıyan rozet için; bu ise bir
 * SINIFLANDIRMA etiketi. İkisini tek bileşene sıkıştırmak, çizimin
 * ayırdığı iki şeyi birleştirmek olurdu.
 *
 * Uyuşmazlıkta çizim kazanır — teslim notunun özeti değil, artboard.
 *
 * ================================================================
 * TONLAR `Rozet` İLE PAYLAŞILIYOR
 * ================================================================
 * Renk kararları aynı: `*-50` dolgu, `*-200` halka, koyu metin. İki
 * ayrı ton tablosu tutmak, birinde düzeltilen kontrastın ötekinde
 * yaşamaya devam etmesi demekti — `hata` tonunun `hata-700` olması
 * tam da böyle bir düzeltmeydi.
 */

const TON: Record<RozetTonu, string> = {
  notr: "bg-notr-100 text-notr-700 ring-notr-200",
  bilgi: "bg-marka-50 text-marka-700 ring-marka-100",
  onay: "bg-onay-50 text-onay-700 ring-onay-200",
  // `uyari-800`: `uyari-500` açık zeminde WCAG AA'nın altında.
  uyari: "bg-uyari-50 text-uyari-800 ring-uyari-200",
  // `hata-700`: `hata-500` kendi açık zemininde 4,09 — AA altı.
  hata: "bg-hata-50 text-hata-700 ring-hata-200",
};

export interface CipProps {
  ton?: RozetTonu;
  children: ReactNode;
  className?: string;
}

export function Cip({ ton = "notr", children, className }: CipProps) {
  return (
    <span
      className={cn(
        // Ölçüler çizimden: radius-alan · 2px 9px · 12px/500
        "rounded-alan inline-flex items-center gap-1 px-2.5 py-0.5",
        "text-xs font-medium ring-1 ring-inset",
        TON[ton],
        className,
      )}
    >
      {children}
    </span>
  );
}
